export default {
  improvementplans: {
    title: '改善計畫',
    high: '高',
    middle: '中',
    low: '低',
    exceed: '超過',
    policy: '規範、方針',
    measure: '對策',
    result: '結果',
    currently_supporting: '處理中',
    completion: '完成',
    ended: '結束（未處理）',
    risk: '風險程度',
    thema: "@:{'common.esg.category'}",
    improvement_plan: '改善計畫',
    deadline_for_completion: '完成期限',
    message_count: '訊息',
    operation: '操作',
    detail: "@:{'common.scorecard.detail'}",
    indicator: '指標',
    indicator_point: '問題點',
    buyer_indicator_point: '評估意見',
    status: '狀態',
    supported: '已處理',
    unsupported: '未處理',
    progress: '進度狀況',
    advice: {
      text_line_1: '請藉由此次的評估，推動更加完善的ESG措施。',
      text_line_2: "可確認問題點的@:{'common.esg.category'}或內容，",
      text_line_3: '並於「製作改善計畫」設定措施內容或完成日期。',
      text_line_4: '請制定改善計畫，為下次的評估採取措施。',
      text_line_5: '可於左邊的圖表確認進展狀況。',
      text_line_6: '如要委託重新評估時，請由',
      contact: '聯絡我們',
      please_contact_us: '諮詢。',
    },
    sub_section_title_1: '處理中的改善計畫',
    no_data_display: '無可顯示的資料。',
    sub_section_title_2: '未處理的問題點',
    buyer_sub_section_title_2: '未處理的評估意見',
    operation_link_text: '製作改善計畫',
    add_advice: '增加問題點',
    sub_section_title_3: '已處理的問題點',
    buyer_sub_section_title_3: '已處理的評估意見',
    revaluation_request: '委託重新評估',
    cautionary_note: '要根據已完成的改善計畫，委託重新評估嗎？',
    asterisked_text: '※委託重新評估時，需要從聯絡我們畫面另外申請。',
    submit_btn_text: '委託重新評估',
    table_state: 'tableState',
    select_a_file: '選擇檔案',
    attached_file: '附加檔案',
    notes: '備註',
    created_improvement_plan: '已建立改善計畫。',
    error_file_upload: '檔案上傳發生錯誤。',
    failed_to_create: '製作改善計畫失敗。請嘗試重新讀入畫面。',
    no_data_found: '未發現改善事項資料。',
    file_upload: {
      filesize_max: '請選擇10MB以下的檔案。',
      max_files: '最多可上傳10件。',
      confirmation_of_deletion: '要刪除此檔案嗎？',
    },
    create_improvement_plan: '製作改善計畫',
    no_data_improvement_plan: '目前無需要處理的改善計畫。',
  },
  buyer_improvementplans: {
    flag: '旗標',
    memo: '備忘',
    flag_on: '加上旗標',
    flag_off: '移除旗標',
    panel: {
      title: '企業資訊／備忘',
      company_memo: '公司內部備忘',
      latest_memo: '最新備忘',
      no_memo: '尚無備忘。',
      check_list: '確認一覽表',
      memo_list: '備忘一覽表',
      // no_assignee: "",
      assignee_select_box: {
        // assignee: "",
        // placeholder: "",
        // create_member: "",
      },
      create_member_modal: {
        // title: "",
        // label: "",
        // place_holder: "",
      },
      delete_member_modal: {
        // title: "",
        // confirm_text: "",
        delete_button_label: "@:{'improvement_plans_detail.chat.delete_confirm.delete_button_label'}",
      },
    },
    back_to_list: '返回一覽表',
    action_cases: '處理件數',
    no_improvements: '無改善點',
    confirm_delete_memo: '是否要刪除1筆公司內部備忘？',
    confirm_delete_memo_title: '刪除公司內部備忘',
    // display_only_is_marked: "",
    create_memo: '製作備忘',
  },
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
    },
  },
}
